import React, { ComponentProps } from 'react'
import { BottomSheetView } from '@gorhom/bottom-sheet'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { BetController } from '@/components/GameAssets/PlayerController/BetController'

export const BetBottomSheetContent = () => {
  const insets = useSafeAreaInsets()
  return (
    <BottomSheetView
      style={{
        paddingBottom: insets.bottom
      }}
    >
      <BetController />
    </BottomSheetView>
  )
}

export type BetBottomSheetContentProps = ComponentProps<typeof BetBottomSheetContent>
